module.exports = __webpack_public_path__ + "static/media/truck.af2931f5.png";